const clearDailyDietPlanCacheObjects = (client) => {
  const serializedState = client.cache.extract();
  const userId =
    Object.values(serializedState).find((item) => item?.__typename === 'Me')?.id || null;

  if (serializedState && userId) {
    const meObject = serializedState[`Me:${userId}`];

    const dailyDietPlanKeys = Object.keys(meObject).filter(
      (item) =>
        item.includes('dailyDietPlan') ||
        item.includes('dailyDietMeal') ||
        item.includes('dietMeal')
    );
    dailyDietPlanKeys.forEach((key) => {
      client.cache.evict({
        id: `Me:${userId}`,
        fieldName: key,
      });
    });

    const shoppingListKeys = Object.keys(meObject).filter((item) => item.includes('shoppingList'));
    shoppingListKeys.forEach((key) => {
      client.cache.evict({
        id: `Me:${userId}`,
        fieldName: key,
      });
    });

    client.cache.evict({ id: `Cookbook:{}` });

    client.cache.gc();
  }
};

export default clearDailyDietPlanCacheObjects;
